import React from 'react';
export const Markers = ({ startTime, endTime, markerTime }) => {
    const totalTime = endTime - startTime;
    const startPercent = ((markerTime - startTime) / totalTime) * 100;
    return (React.createElement("div", { style: {
            position: 'absolute',
            height: 6,
            zIndex: 2,
            backgroundColor: '#de3617',
            cursor: 'pointer',
            left: `calc(${startPercent}% - 2px)`,
            width: `4px`,
            pointerEvents: 'none',
        } }));
};
//# sourceMappingURL=Markers.js.map